var _getFilterLocalStorag, _getFilterLocalStorag2;
import { List } from 'immutable';
import PortalIdParser from 'PortalIdParser';
import { buildTypedMap } from '../types/TypedMap';
import { SET_FILTER, SET_INITIAL_FILTERS } from '../actions/ActionTypes';
import { FILTERS, TIME_PERIOD_FILTERS } from '../constants/FiltersConstants';
import { HUBSPOT_DEFINED_FORECAST_TYPE_ID } from '../constants/ForecastTypeConstants';
import { DEAL_STAGE } from '../constants/DealGroupingType';
import { getFilterLocalStorageValue, saveFiltersToLocalStorage } from '../utils/filters';
export const initialFilterState = buildTypedMap({
  [FILTERS.FORECAST_TYPE]: ((_getFilterLocalStorag = getFilterLocalStorageValue()) === null || _getFilterLocalStorag === void 0 || (_getFilterLocalStorag = _getFilterLocalStorag.get(`${PortalIdParser.get()}`)) === null || _getFilterLocalStorag === void 0 ? void 0 : _getFilterLocalStorag.get(FILTERS.FORECAST_TYPE)) || HUBSPOT_DEFINED_FORECAST_TYPE_ID,
  [FILTERS.PIPELINE]: List([]),
  // will be set in setInitialFilters
  [FILTERS.TIME_PERIOD]: TIME_PERIOD_FILTERS.THIS_MONTH,
  [FILTERS.DEAL_GROUPING]: List(),
  // cleanup in #2401
  [FILTERS.DEAL_STAGE_GROUPINGS]: List(),
  [FILTERS.FORECAST_CATEGORY_GROUPINGS]: List(),
  [FILTERS.DEAL_GROUPING_TYPE]: ((_getFilterLocalStorag2 = getFilterLocalStorageValue()) === null || _getFilterLocalStorag2 === void 0 || (_getFilterLocalStorag2 = _getFilterLocalStorag2.get(`${PortalIdParser.get()}`)) === null || _getFilterLocalStorag2 === void 0 ? void 0 : _getFilterLocalStorag2.get(FILTERS.DEAL_GROUPING_TYPE)) || DEAL_STAGE
});
export default function filters(state = initialFilterState, action) {
  switch (action.type) {
    case SET_FILTER:
      {
        const {
          filter,
          value
        } = action;
        const nextState = state.merge({
          [filter]: value
        });
        saveFiltersToLocalStorage(nextState);
        return nextState;
      }
    case SET_INITIAL_FILTERS:
      {
        const {
          filterState
        } = action;
        const nextState = state.merge(filterState);
        saveFiltersToLocalStorage(nextState);
        return nextState;
      }
    default:
      return state;
  }
}